export const WORK_AREAS = ['cold_call','my_contacts','promo','opportunities','referrals'];
export const hasArea = (user, area) => !user?.areas || user.areas.includes(area);
export const canPrewarm = user => ['jan.nesic@loewen-stark.net','philip.bogdan@loewen-stark.net'].includes((user?.email || '').trim().toLowerCase()) && hasArea(user, 'cold_call');
export const hasWork = user => WORK_AREAS.some(a => hasArea(user,a));
export function routeAreas(to) {
  const raw = typeof to === 'string' ? to : `${to?.pathname || ''}${to?.search || ''}`;
  const [path,query=''] = raw.split('?'); const p = new URLSearchParams(query);
  if(path==='/m/prewarm-call')return ['cold_call'];
  if(path==='/m/call')return [p.get('mk')==='1'?'my_contacts':p.get('promo')==='1'?'promo':'cold_call'];
  if(['/m/smart','/m/leads','/m/interesting-contacts','/m/tasks','/m/followups','/m/mailing','/m/contacted'].includes(path)||path.startsWith('/m/contact/'))return WORK_AREAS;
  const routes={'/m/home':'home','/m/callbacks':'cold_call','/m/networking':'my_contacts','/m/my-contacts':'my_contacts','/m/promo':'promo','/m/opportunities':'opportunities','/m/referrals':'referrals','/m/performance':'analytics'};
  const entry=Object.entries(routes).find(([r])=>path===r||path.startsWith(r+'/'));
  return entry?[entry[1]]:[];
}
export const canNavigate = (user,to) => { if((typeof to === "string" ? to : to?.pathname)?.split("?")[0] === "/m/prewarm-call" && !canPrewarm(user))return false; if((typeof to === "string" ? to : to?.pathname)?.split("?")[0] === "/m/email-campaigns" && (user?.email||"").trim().toLowerCase()!=="jan.nesic@loewen-stark.net")return false; const required=routeAreas(to);return !required.length||required.some(a=>hasArea(user,a)); };
export function homeFor(user){
  if(user?.permissions?.can_review_scenes===true)return '/scene-review';
  if(user?.role==='promoter')return '/promoter';
  if(user?.role==='admin')return '/admin/dashboard';
  const order=user?.role==='vertriebspartner'?['my-contacts','home','opportunities','performance']:['home','promo','my-contacts','opportunities','performance'];
  return order.map(p=>'/m/'+p).find(p=>canNavigate(user,p))||'/m/profile';
}
export const sourceArea = source => ({personal:'my_contacts',private:'my_contacts',own:'my_contacts',promo:'promo',referral:'referrals'}[source]||'cold_call');
export const customerArea = customer => customer?.source === 'manual' && customer?.customer_type === 'private' ? 'my_contacts' : sourceArea(customer?.source);
export const sourceHome = source => ({my_contacts:'/m/my-contacts',promo:'/m/promo',referrals:'/m/referrals',cold_call:'/m/call'}[sourceArea(source)]);
export function safeInternal(path){return typeof path==='string'&&/^\/(m\/|admin\/|team\/|promoter(?:$|\?))/.test(path)&&!path.includes('\\')?path:null;}
export function parentFor(path,user){
  if(path.startsWith('/m/contact/'))return homeFor(user);
  if(path.startsWith('/m/opportunities/'))return '/m/opportunities';
  if(path.startsWith('/m/promo/'))return '/m/promo';
  if(path==='/m/referrals/network')return '/m/referrals';
  if(path.startsWith('/admin/customers/'))return '/admin/customers';
  if(path.startsWith('/team/customers/'))return '/team/customers';
  if(path.startsWith('/admin/'))return '/admin/dashboard';
  if(path.startsWith('/team/'))return '/team/cockpit';
  return homeFor(user);
}

export function contactWork(id,from){return `/m/contact/${encodeURIComponent(id)}${safeInternal(from)?`?returnTo=${encodeURIComponent(from)}`:''}`;}



